module.exports = __webpack_public_path__ + "4b9a4ae21073328de2b59adae8e1111d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/intuit_2022_chart.png
// module id = 1687
// module chunks = 0